var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{staticClass:"dropzone",attrs:{"action":_vm.url,"enctype":"multipart/form-data","id":'dropzone-' + _vm._uid}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fallback"},[_c('input',{attrs:{"name":"file","type":"file","multiple":""}})])
}]

export { render, staticRenderFns }